import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [latest, setLatest] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // capture utm_source on first visit
    try {
      const params = new URLSearchParams(window.location.search);
      const src = (params.get("utm_source") || params.get("ref") || "").toLowerCase();
      if (src && !localStorage.getItem("life101_source")) {
        localStorage.setItem("life101_source", src);
      } else if (!localStorage.getItem("life101_source")) {
        const ref = document.referrer || "";
        let detected = "direct";
        if (ref.includes("instagram")) detected = "instagram";
        else if (ref.includes("youtube") || ref.includes("youtu.be")) detected = "youtube";
        else if (ref.includes("tiktok")) detected = "tiktok";
        else if (ref.includes("facebook") || ref.includes("fb.com")) detected = "facebook";
        else if (ref.includes("twitter") || ref.includes("x.com") || ref.includes("t.co")) detected = "twitter";
        else if (ref.includes("google")) detected = "google";
        else if (ref) detected = "other";
        localStorage.setItem("life101_source", detected);
      }
    } catch {}

    const token = localStorage.getItem("life101_user_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => {
      setUser(r.data.user);
      setLatest(r.data.latest_submission);
    }).catch(() => {
      localStorage.removeItem("life101_user_token");
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password, remember) => {
    const { data } = await api.post("/auth/login", { email, password, remember });
    localStorage.setItem("life101_user_token", data.token);
    setUser(data.user);
    const me = await api.get("/auth/me");
    setLatest(me.data.latest_submission);
    return data.user;
  };

  const register = async (form) => {
    const source = localStorage.getItem("life101_source") || "direct";
    const { data } = await api.post("/auth/register", { ...form, source });
    localStorage.setItem("life101_user_token", data.token);
    setUser(data.user);
    setLatest(null);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("life101_user_token");
    localStorage.removeItem("life101_results");
    setUser(null);
    setLatest(null);
  };

  const refreshLatest = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setLatest(data.latest_submission);
    } catch {}
  };

  return (
    <AuthCtx.Provider value={{ user, latest, loading, login, register, logout, refreshLatest }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
